import React, { useContext, useEffect, useState } from "react";
import { AditivosProps } from "./types";
import ProcessoService from "../../../../../../services/ProcessoService";
import { DommusAlert } from "../../../../../../components/DommusAlert";
import { AccordionContext, Button, Container } from "react-bootstrap";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import DommusLoading from "../../../../../../components/DommusLoading/DommusLoading";
import { ModalDommusTSX } from "../../../../../../components/ModalTS";
import { IframeAditivo } from "./IframeAditivo";
import { ListaAditivos } from "./ListaAditivos";
import { SecaoAditivosContext } from "../../../../../../contexts/SecaoAditivosContext"
import { AditivoType } from "../../../../../../contexts/SecaoAditivosContext/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function SecaoAditivos({ ticket }: AditivosProps) {
  const promiseAditivos = 'busca-aditivos-processo'
  const [aditivos, setAditivos] = useState<AditivoType[]>([])
  const activeEventKey = useContext(AccordionContext)
  const { modalAditivoAberto, fecharModalAditivo, abrirModalAditivo } = useContext(SecaoAditivosContext)
  const { promiseInProgress } = usePromiseTracker({ area: promiseAditivos })

  useEffect(() => {
    setAditivos([])
  }, [ticket])

  useEffect(() => {
    buscarAditivosPorIdProcesso()
  }, [activeEventKey])

  function buscarAditivosPorIdProcesso() {
    if(activeEventKey == 'aditivos' && !aditivos.length) {
      trackPromise(ProcessoService.buscarAditivosPorIdProcesso(ticket.id_processo), promiseAditivos)
        .then(response => setAditivos(response.data))
        .catch(error => {
          console.log(error)
          console.log(error?.response)
          DommusAlert({
            title: 'Ooops...',
            message: 'Houve um erro ao buscar os aditivos do processo.',
            type: 'error'
          })
        })
    }
  }

  return <Container className="py-3 fundo-cinza-claro">
    {
      promiseInProgress && 
      <DommusLoading loadWrapperPosition="relative" fundo="#f8f8f8"/> || <>
        <ListaAditivos aditivos={aditivos}/>
        <Button className="float-right mb-3 mt-2" variant="success" size="sm" onClick={() => abrirModalAditivo?.()}>
           <FontAwesomeIcon icon="plus-circle"/> Novo Aditivo
        </Button>
      </> 
    }
    <ModalDommusTSX 
      bodyStyle={{padding: "none"}}
      titulo={'Aditivos'}
      open={modalAditivoAberto}
      close={fecharModalAditivo}
      content={<IframeAditivo/>}
    />
  </Container>
}
